module.exports = __webpack_public_path__ + "static/media/addDriver.a093519e.svg";